import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

//components
// import SelectDeliveryArea from "components/outlet-based-areas/SelectDeliveryArea";
import ViewBasket from "components/basket/ViewBasket";
import { FixedFooter } from "components";
import WithLoading from "components/Hoc/WithLoading";
// import { StoreListForDelivery } from "components/store/StoreList";
import Footer from "components/Footer";
//hooks
import { useCustomHistory } from "hooks";
//constants
import * as ROUTE_CONSTANTS from "routes/constants";
// import { NotPersistAction } from "store/actions";
// import { StoreListForPickup } from "components/store/StoreList";
import { TranslationText } from "components/TextTranslationContainer";
import ConditionalRenderer from "components/ConditionalRenderer";

//TODO: requies code cleanup
const MenuContainer = ({ menu, children, searchTerm, setSearch }) => {
  //hooks
  const params = useParams();
  // const { currentLang } = useLang();
  const router = useCustomHistory();
  //global state
  // const { areasError, stores } = useSelector((state) => state.brand);
  const { DomainType, orderType } = useSelector((state) => state.AppReducer);
  const { storeModal, areaModal, pickupStoreModal } = useSelector(
    (state) => state.NotPersist
  );

  //view basket page
  const viewBasketPage = () => {
    let url = ROUTE_CONSTANTS.OUTLET_BASKET[1];
    router(url, `/${params?.domainName}${url}`, DomainType);
  };
  useEffect(() => {
    searchTerm && setSearch("");
  }, [orderType?.serviceType]);

  return (
    <WithLoading>
      {menu?.length === 0 ? (
        <div className="h-app-height p-4">
          {searchTerm?.length > 0 && (
            <TranslationText className="text-center mt-4 font-semibold text-red-500" text="We didn’t find any results for" contentProps={{ searchTerm: searchTerm }} />
          )}
        </div>
      ) : (
        children
      )}

      <Footer />
      <ConditionalRenderer condition={!(storeModal && areaModal && pickupStoreModal)}>
      <FixedFooter basketFooter={true} page={true} from="menu" showExtraSpace={false}>
        <ViewBasket {...{ viewBasketPage }} />
      </FixedFooter>
      </ConditionalRenderer>

      {/* TODO:remove the following in code cleanup */}
      {/* <CustomModal
        open={storeModal}
        reduxAction={NotPersistAction.setModalClose()}
        bodyclasses="flex"
        overlayClasses="fixed ccc h-app-height w-screen top-0  bg-black bg-opacity-50 overflow-hidden transition ease-linear duration-700 z-30"
      >
        <StoreListForDelivery
          updateTemporaryLocation={() => {}}
          shouldCloseOnEsc="No"
          shouldCloseOnOverlayClick="No"
          stores={stores}
          header={false}
          headerLabel=""
          styleClasses={`fixed bottom-0 h-5 bg-white min-h-70p max-460 o1111verflow-y-auto rounded-t-lg min-h-60p ${
            currentLang === "AR" ? "border-sc-l" : "border-sc"
          }`}
        />
      </CustomModal> */}
      {/* <CustomModal
        open={areaModal}
        reduxAction={NotPersistAction.toggleAreaModal(false)}
        bodyclasses="flex"
        overlayClasses="fixed h-screen w-screen top-0  bg-black bg-opacity-50 overflow-hidden transition ease-linear duration-700 z-30"
      >
        <SelectDeliveryArea
          header={false}
          error={areasError}
          headerLabel=""
          styleClasses={`fixed bottom-0 h-5 bg-white min-h-70p max-460  rounded-t-lg min-h-60p ${
            currentLang === "AR" ? "border-sc-l" : "border-sc"
          }`}
        />
      </CustomModal> */}
      {/* <CustomModal
        shouldCloseOnEsc="No"
        shouldCloseOnOverlayClick="No"
        open={pickupStoreModal}
        reduxAction={NotPersistAction.togglePickupStoreModal(false)}
        bodyclasses="flex"
        overlayClasses="fixed h-screen w-screen top-0 bg-black bg-opacity-50 overflow-hidden transition ease-linear duration-700 z-20"
      >
        <StoreListForPickup
          stores={stores}
          header={false}
          headerLabel=""
          styleClasses="fixed bottom-0 h-5 bg-white min-h-70p max-460 oooooverflow-y-auto rounded-t-lg min-h-60p  border-sc"
        />
      </CustomModal> */}

      {/* uncomment this is found any issue with store and location modals */}
      {/* <StoreAndLocationModals /> */}
    </WithLoading>
  );
};
export default MenuContainer;
